import { FunctionComponent, memo } from 'react';
import {
  Hydrate,
  QueryClient,
  QueryClientProvider,
  DehydratedState,
} from '@tanstack/react-query';

import PageLoader from 'global/Loading/PageLoader';
import MainLayout from 'global/MainLayout';
import DocumentLayout from 'global/DocumentLayout';
import useProtectedRoute from 'hooks/useProtectedRoute';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/credentials';

interface IGlossaryLayout {
  children: React.ReactNode;
  dehydratedState: DehydratedState;
  Layout?: FunctionComponent<any>;
}

function GlossaryLayout({ children, dehydratedState, Layout = MainLayout }: IGlossaryLayout) {
  const { isLoggedIn } = useSelector(selectors);
  const { isLoaded } = useProtectedRoute();
  const queryClient = new QueryClient();
  const LayoutComponent = isLoggedIn ? Layout : DocumentLayout;

  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>
        <LayoutComponent>
          {isLoggedIn && <PageLoader loaded={isLoaded} />}
          {children}
        </LayoutComponent>
      </Hydrate>
    </QueryClientProvider>
  );
}

export default memo(GlossaryLayout);
